// reason: these are the color tokens so they are hardcoded
// eslint-disable @dhl/mui/no-hardcoded-colors
export const additional = {
  brightYellow: '#FFD700',
  hotPink: '#E91E63',
  dangerRed: '#FF000D',
  turquoise: '#00B2A9',
  limeGreen: '#A8E600',
  vibrandBlue: '#005BBB',
  mysteriousPurple: '#6A0DAD',
} satisfies Record<string, string>
